// extracted by mini-css-extract-plugin
module.exports = {"back":"NotFound404_back__3d5TX","backBtn":"NotFound404_backBtn__2aEAg","icon":"NotFound404_icon__15YBP"};